import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";

import { Icon } from "@iconify/react";
import classes from "./TextAreaOverlay.module.scss";

const TextAreaOverlay = forwardRef((props, ref) => {
	const inputRef = useRef();

	const [focus, setFocus] = useState("");
	const [active, setActive] = useState("");

	const inputHandler = (e) => {
		if (props.type === "number") {
			const char = String.fromCharCode(e.which);
			if (!/[0-9]/.test(char)) {
				e.preventDefault();
			}
		}
	};

	const onFocus = () => {
		setFocus("focus");
		if (props.onFocus) props.onFocus();
	};

	const onBlur = () => {
		setFocus("");
		if (props.onBlur) props.onBlur();
	};

	const onChange = (event) => {
		if (props.onChange) props.onChange(event);
	};

	useImperativeHandle(ref, () => ({
		focus: () => {
			inputRef.current.focus();
		},
	}));

	useEffect(() => {
		if (inputRef?.current?.value) setActive("active");
		else setActive("");
	}, [inputRef]);

	return (
		<div
			className={`${props.className || ""} ${classes.TextInput} ${
				props.isValid === false ? classes.invalid : ""
			}`}
		>
			{props.label && (
				<label
					className={`${classes.label} ${focus ? classes[focus] : ""} ${active ? classes[active] : ""}`}
					htmlFor={props.id}
				>
					{props.label}
					{props.mandatory && <Icon className={classes.mandatory} icon="oui:asterisk" />}
				</label>
			)}
			{props.onSearch && (
				<Icon
					className={`${classes.search} ${focus ? classes[focus] : ""} ${active ? classes[active] : ""}`}
					onClick={props.onSearch}
					icon="arcticons:xiaoyuan-search"
				/>
			)}
			<textarea
				className={`${classes.input} ${focus ? classes[focus] : ""} ${active ? classes[active] : ""}`}
				ref={inputRef}
				id={props.id}
				name={props.name}
				value={props.value}
				onChange={onChange}
				placeholder={props.placeholder}
				onKeyPress={inputHandler}
				defaultValue={props.defaultValue}
				disabled={props.disabled}
				required={props.mandatory}
				onFocus={onFocus}
				onBlur={onBlur}
				onKeyDown={props.onKeyDown}
				cols={props.cols || 40}
				rows={props.rows || 5}
			/>
			{props.onClose && (
				<Icon
					className={`${classes.close} ${focus ? classes[focus] : ""} ${active ? classes[active] : ""}`}
					onClick={props.onClose}
					icon="ei:close-o"
				/>
			)}
			{props.isValid === false && props.error && (
				<div className={classes.error}>
					<p>{props.error}</p>
				</div>
			)}
		</div>
	);
});

export default TextAreaOverlay;
